import { DTOConstructor } from "./dto-constructor";

export class AccountDTO extends DTOConstructor<AccountDTO> {
    id: number;
    name: string;
    email?: string;
    firstName: string;
    lastName: string;
    admin: boolean;
    profiles: number[];
    hasPassword: boolean;
}
